const ku = {
  // Navigation
  'nav.home': 'سەرەکی',
  'nav.about': 'دەربارەی ئێمە',
  'nav.directory': 'ڕێنمای پیشەیی',
  'nav.knowledge': 'ناوەندی زانیاری',
  'nav.impact': 'کاریگەری جیهانی',
  'nav.contact': 'پەیوەندی',
  'nav.join': 'بەشداری بکە',

  // Hero Section
  'hero.title': 'تۆڕی پشتگیری پیشەیی بۆ یەکخستن لە هۆڵەندا',
  'hero.subtitle': 'پێشکەشکردنی پشتگیری مادی و مەعنەوی بۆ خەڵکی هەموو ڕەگەز، زمان، ئایین و باوەڕەکان لە هەموو قۆناغێکدا لە کامپی پەنابەرانەوە تا وەرگرتنی هاوڵاتیبوون',
  'hero.cta.primary': 'بەشداری تۆڕەکەمان بکە',
  'hero.cta.secondary': 'زیاتر بگەڕێ',

  // About Section
  'about.title': 'دەربارەی ئێمە',
  'about.subtitle': 'کۆمەڵگەیەکی جیهانی کە پشتگیری یەکخستن دەکات بۆ هەموو ئەوانەی دێنە هۆڵەندا',
  'about.mission.title': 'ئامانجەکەمان',
  'about.mission.text': 'بنکەی IPN ئامانجی ئەوەیە کە پشتگیری مادی و مەعنەوی گشتگیر پێشکەش بکات بۆ خەڵکی هەموو ڕەگەز، زمان، ئایین و باوەڕەکان کە دێنە هۆڵەندا، لە گەیشتنیان بە کامپەکانی پەنابەرانەوە لە ماوەی چاوەڕوانیدا، دۆزینەوەی نیشتەجێبوون، وەرگرتنی هاوڵاتیبوون و دواتر، بۆ دڵنیابوون لە یەکخستنی سەرکەوتوو لە کۆمەڵگای هۆڵەندی.',
  'about.vision.title': 'بینینەکەمان',
  'about.vision.text': 'دروستکردنی کۆمەڵگەیەک لە هۆڵەندا کە هەموو کەس دەرفەتی یەکسانیان هەیە، جۆراوجۆری کلتووری وەک سامان دەبینرێت، و یەکخستن بە سەرکەوتوویی دەستدەکەوێت.',
  'about.values.title': 'بەهاکانمان',
  'about.values.text': 'گشتگیری، یەکڕیزی، پیشەیی و بەرپرسیارێتی کۆمەڵایەتی بنەماکانی ڕێکخراوەکەمانن، کە لە هەموو ئەوەی دەیکەین ڕەنگدانەوەیان هەیە.',

  // Core Values
  'values.title': 'بەها بنەڕەتیەکانمان',
  'values.subtitle': 'پرەنسیپەکان کە کارەکەمان ڕێنمایی دەکەن',
  'values.ethics.title': 'گشتگیری',
  'values.ethics.text': 'پشتگیری و ڕێزی یەکسان بۆ خەڵکی هەموو ڕەگەز، زمان، ئایین و باوەڕەکان',
  'values.wisdom.title': 'یەکڕیزی',
  'values.wisdom.text': 'کلتوورێکی یەکگرتوویی کۆمەڵایەتی و یارمەتیدانی دووقات',
  'values.service.title': 'پشتگیری پیشەیی',
  'values.service.text': 'پشتگیری یەکخستن لە ڕێگەی ڕێنمایی شارەزایانە و چارەسەرە کردارییەکانەوە',
  'values.impact.title': 'کاریگەری کۆمەڵایەتی',
  'values.impact.text': 'دروستکردنی گۆڕانکاری بەردەوام و واتادار لە کۆمەڵگای هۆڵەندی',

  // Professional Directory
  'directory.title': 'ڕێنمای پیشەیی',
  'directory.subtitle': 'پەیوەندی بکە بە شارەزایانەوە کە دەتوانن یارمەتیت بدەن لە پرۆسەی یەکخستندا',
  'directory.search': 'گەڕان بۆ پیشەییەکان...',
  'directory.filter.all': 'هەموو بوارەکان',
  'directory.filter.education': 'پەروەردە',
  'directory.filter.healthcare': 'چاودێری تەندروستی',
  'directory.filter.technology': 'تەکنەلۆژیا',
  'directory.filter.business': 'بازرگانی',
  'directory.filter.law': 'یاسا',
  'directory.filter.engineering': 'ئەندازیاری',
  'directory.viewProfile': 'بینینی پرۆفایل',

  // Knowledge Hub
  'knowledge.title': 'ناوەندی زانیاری و سەرچاوەکان',
  'knowledge.subtitle': 'ڕێنما، وتار و سەرچاوەکان بۆ پرۆسەی یەکخستنەکەت',
  'knowledge.featured': 'بڵاوکراوەکانی تایبەت',
  'knowledge.readMore': 'زیاتر بخوێنەوە',
  'knowledge.viewAll': 'بینینی هەموو بڵاوکراوەکان',

  // Global Impact
  'impact.title': 'بەرنامەکانی پشتگیریمان',
  'impact.subtitle': 'ئێمە لەگەڵتدا لە هەموو قۆناغێکی گەشتی یەکخستنەکەتدا',
  'impact.education.title': 'پشتگیری پەروەردە و زمان',
  'impact.education.text': 'خولی زمانی هۆڵەندی، ڕاوێژکاری پەروەردەیی و ڕێنمایی لە پرۆسەی یەکسانکردنی بڕوانامەدا',
  'impact.healthcare.title': 'پشتگیری تەندروستی و کۆمەڵایەتی',
  'impact.healthcare.text': 'ڕێنمایی سیستەمی چاودێری تەندروستی، پشتگیری دەروونی و بەرنامەکانی یارمەتی کۆمەڵایەتی',
  'impact.research.title': 'پشتگیری کار و پیشە',
  'impact.research.text': 'گەڕان بۆ کار، ئامادەکردنی CV، ڕاهێنانی پیشەیی و ڕاوێژکاری کاروباری',
  'impact.humanitarian.title': 'پشتگیری یاسایی و کاروباری',
  'impact.humanitarian.text': 'ڕێنمایی پیشەیی لە مۆڵەتی نیشتەجێبوون، داواکاری هاوڵاتیبوون و پرۆسە یاساییەکاندا',

  // Testimonials
  'testimonials.title': 'لە ئەندامەکانمانەوە',
  'testimonials.subtitle': 'دەنگەکان لە کۆمەڵگەکەمانەوە',

  // Contact
  'contact.title': 'پەیوەندیمان پێوە بکە',
  'contact.subtitle': 'پرسیارت هەیە؟ پێمان خۆشە لێت ببیستین',
  'contact.name': 'ناوت',
  'contact.email': 'ئیمەیڵەکەت',
  'contact.subject': 'بابەت',
  'contact.message': 'نامەکەت',
  'contact.send': 'ناردنی نامە',
  'contact.info.title': 'زانیاری پەیوەندی',
  'contact.info.address': 'ناونیشان',
  'contact.info.phone': 'تەلەفۆن',
  'contact.info.email': 'ئیمەیڵ',

  // Footer
  'footer.about.title': 'دەربارەی بنکەی IPN',
  'footer.about.text': 'تۆڕێکی پیشەیی کە پشتگیری گشتگیر پێشکەش دەکات بۆ هەموو ئەو کەسانەی دێنە هۆڵەندا لە کاتی پرۆسەی یەکخستنیاندا.',
  'footer.quickLinks': 'بەستەرە خێراکان',
  'footer.connect': 'بەستراو بمێنەوە',
  'footer.newsletter': 'بەشداری نامەی هەواڵمان بکە',
  'footer.newsletter.placeholder': 'ئیمەیڵەکەت بنووسە',
  'footer.newsletter.button': 'بەشداربوون',
  'footer.copyright': '© 2024 بنکەی IPN. هەموو مافێک پارێزراوە.',
  'footer.privacy': 'سیاسەتی تایبەتێتی',
  'footer.terms': 'مەرجەکانی خزمەتگوزاری',

  contact: {
    form: {
      name: 'ناو',
      namePlaceholder: 'ناوی خۆت بنووسە',
      email: 'ئیمەیڵ',
      emailPlaceholder: 'ئیمەیڵەکەت بنووسە',
      phone: 'تەلەفۆن',
      phonePlaceholder: 'ژمارەی تەلەفۆنەکەت بنووسە',
      subject: 'بابەت',
      subjectPlaceholder: 'بابەتی نامەکەت',
      message: 'نامە',
      messagePlaceholder: 'نامەکەت لێرە بنووسە...',
      maxChars: 'زۆرترین 500 پیت',
      submit: 'نامە بنێرە',
      sending: 'ناردن...',
      successMessage: 'نامەکەت بە سەرکەوتوویی نێردرا! زوو پەیوەندیت پێوە دەکەینەوە.',
      errorMessage: 'هەڵەیەک ڕوویدا. تکایە دووبارە هەوڵ بدەرەوە.',
    },
    workingHours: 'کاتی کار',
    weekdays: 'ڕۆژانی هەفتە',
    weekend: 'کۆتایی هەفتە',
    closed: 'داخراو',
  },
  news: {
    title: 'سیستەمی شوێنکەوتنی هەواڵەکانی پەنابەران',
    subtitle: 'شوێنی تازەترین هەواڵەکان دەربارەی پەنابەران لە IND، COA، شارەوانیەکان و میدیا بکەوە. بەشداری لە نامەی مانگانەمان ببە و هیچ پێشکەوتنێکی گرنگ لە دەست مەدە.',
    subscribe: 'بەشداری نامەی مانگانە ببە',
    new: 'نوێ',
    readMore: 'زیاتر بخوێنەرەوە',
    categories: {
      all: 'هەموو',
      municipality: 'شارەوانیەکان',
      media: 'میدیا',
      policy: 'سیاسەت',
    },
    items: {
      ind1: {
        title: 'IND ڕێکارە نوێیەکانی داواکاری ڕاگەیاند',
        summary: 'IND ڕێکارە نوێیەکان و پرۆسەی هەڵسەنگاندنی خێراتر بۆ داواکاریەکانی پەنابەری دەستپێدەکات. گۆڕانکاریە گرنگەکان بۆ داواکاران.',
      },
      coa1: {
        title: 'COA ناوەندی وەرگرتنی نوێ دەکاتەوە',
        summary: 'COA ڕاگەیاندنی کردووە کە ناوەندی وەرگرتنی نوێ لە سەرانسەری هۆڵەندا دەکاتەوە بۆ وەڵامدانەوەی داواکاری زیادبوو. توانا بە 30% زیاد دەبێت.',
      },
      municipality1: {
        title: 'ئەمستەردام بەرنامەکانی یەکخستن فراوان دەکات',
        source: 'شارەوانی ئەمستەردام',
        summary: 'شارەوانی ئەمستەردام وەبەرهێنان لە خولی زمان و بەرنامەکانی دامەزراندنی کار بۆ پەنابەران زیاد دەکات. بودجەی نوێ پەسەند کرا.',
      },
      media1: {
        title: 'یەکخستنی پەنابەران لە هۆڵەندا: چیرۆکەکانی سەرکەوتن',
        summary: 'NOS دۆکیومێنتاریەکی تایبەت دەربارەی نموونەکانی یەکخستنی سەرکەوتوو و بەشدارییەکانی پەنابەران لە کۆمەڵگای هۆڵەندی بڵاوکردەوە.',
      },
      policy1: {
        title: 'یاسای نوێی یەکخستن لە پەرلەمان پەسەند کرا',
        summary: 'پەرلەمانی هۆڵەندا یاسایەکی نوێی پەسەند کرد کە پرۆسەی یەکخستن بۆ پەنابەران ئاسانتر و پشتگیری دەکات. یاسا لە 2024 دەست پێدەکات.',
      },
      ind2: {
        title: 'IND سیستەمی داواکاری دیجیتاڵی دەست پێکرد',
        summary: 'IND پلاتفۆرمێکی نوێی ناساند کە ڕێگە بە داواکاریەکانی پەنابەری دەدات بە شێوەی دیجیتاڵی پێشکەش بکرێن. پرۆسەکە ئێستا خێراتر و ڕوونترە.',
      },
    },
    infoBox: {
      title: 'شوێنکەوتنی هەواڵی خۆکار',
      description: 'سیستەمەکەمان ڕۆژانە IND، COA، Overheid.nl، شارەوانیەکان و ڕێکخراوە میدیاییە سەرەکیەکان پشکنین دەکات و بە شێوەیەکی خۆکار هەواڵە گرنگەکان دەربارەی پەنابەران کۆدەکاتەوە. بەشداری نامەی مانگانەمان ببە بۆ ئاگاداربوون لە هەموو پێشکەوتنە گرنگەکان.',
    },
    modal: {
      title: 'بەشداری نامەی مانگانە ببە',
      description: 'ئیمەیڵەکەت بنووسە و گرنگترین هەواڵەکان دەربارەی پەنابەران ڕاستەوخۆ لە سندوقی ئیمەیڵەکەتدا وەربگرە هەموو مانگێک.',
      emailLabel: 'ناونیشانی ئیمەیڵ',
      emailPlaceholder: 'example@email.com',
      subscribeButton: 'بەشداری ببە',
      subscribing: 'بەشداریکردن...',
      successMessage: 'بە سەرکەوتوویی بەشداریت کرد! زوو یەکەم نامەکەت وەردەگریت.',
      errorMessage: 'هەڵەیەک ڕوویدا. تکایە دووبارە هەوڵ بدەرەوە.',
    },
  },

  integration: {
    title: 'Pêvajoya Me ya Yekbûnê',
    subtitle: 'Em di her gavê de bi te re ne, ji gihîştina te Hollandayê heya welatîtiyê. Ev pêvajoya 6 gavî ye ku em ê te bi rê ve bibin.',
    step: 'Gav',
    requiredDocuments: 'Belgeyên Pêwîst',
    tips: 'Şîretên Girîng',
    getSupport: 'Di Vê Gavê de Piştgirî Bistîne',
    successTitle: 'Çîrokên Serketinê Bibîne',
    successDescription: 'Bi hezaran kes vê pêvajoyê bi serketî temam kirine. Ji ezmûnên wan îlham bistîne û tu jî serkeve.',
    readStories: 'Çîrokan Bixwîne',
    
    steps: {
      step1: {
        shortTitle: 'Gihîştin',
        title: 'Gihîştin û Tomarkirin',
        description: 'Tomarkirina yekem li Ter Apel û rêkeftinên man a demkî',
        duration: '1-3 roj',
        documents: [
          'Pasaport an belgeya nasnameyê',
          'Belgeyên rêwîtiyê',
          'Belgeyên perwerde û karê heke hene',
          'Belgeyên ku rewşa malbatê nîşan didin'
        ],
        tips: [
          'Hemû belgeyên xwe di cîhekî ewle de bihêle',
          'Di hevpeyvîna yekem de rast û vekirî be',
          'Ji karûbarên wergêrê sûd werbigire',
          'Bi baldarî guhdarî agahdariyên pêşkêşkirî bike'
        ]
      },
      step2: {
        shortTitle: 'Hevpeyvîn',
        title: 'Hevpeyvînên IND',
        description: 'Daxwaziya penaberiyê û hevpeyvînên berfireh, vegotin a çîroka te',
        duration: '6-12 meh',
        documents: [
          'Belgeyên nasnameyê û wêne',
          'Belgeyên ku sedemên berdan a welatê te piştgirî dikin',
          'Delîlên tehdîd an zulman heke hene',
          'Belgeyên ku girêdanên malbatê nîşan didin'
        ],
        tips: [
          'Çîroka xwe bi awayekî hevgirtî û berfireh vegêre',
          'Hemû pirsan bi baldarî bersiv bide',
          'Piştgiriya hiqûqî bistîne',
          'Ji karûbarên piştgiriya derûnî sûd werbigire'
        ]
      },
      step3: {
        shortTitle: 'Bicîbûn',
        title: 'Destûra Nîştecivaniyê û Xanî',
        description: 'Stendin a destûra nîştecivaniyê û dabeşkirina xaniya herdemî, destpêka jiyana te ya nû',
        duration: '2-6 meh',
        documents: [
          'Biryara IND û destûra nîştecivaniyê',
          'Tomarkirina BSN (Jimareya Karûbarên Welatî)',
          'Belgeya bîmeya tenduristiyê',
          'Agahdariyên hesabê bankayê'
        ],
        tips: [
          'Bilez xwe li şaredariyê tomar bike',
          'Bîmeya tenduristiyê bistîne (mecbûrî ye)',
          'Ji bo alîkariya civakî daxwaz bike',
          'Bi navçe û cîranên xwe re nas bibe'
        ]
      },
      step4: {
        shortTitle: 'Perwerde',
        title: 'Perwerdehiya Ziman û Yekbûnê',
        description: 'Kursa zimanê hollandî û bernameyên yekbûna civakî, lihevhatina çandî',
        duration: '6-36 meh',
        documents: [
          'Belgeya tomarkirina îmtîhana yekbûnê',
          'Belgeya beşdariya kursa zimanê',
          'Raporên pêşveçûna perwerdeyê',
          'Belgeyên encamên îmtîhanê'
        ],
        tips: [
          'Bi rêkûپêك beşdarî kursan bibe',
          'Li malê jî hollandî pratîk bike',
          'Beşdarî bûyerên herêmî bibe',
          'Ji bo karên dilxwazî daxwaz bike'
        ]
      },
      step5: {
        shortTitle: 'Kar',
        title: 'Lêgerîna Kar û Pîşe',
        description: 'Perwerdehiya pîşeyî, piştgiriya lêgerîna kar û karûbarên plansaziya pîşeyî',
        duration: '3-12 meh',
        documents: [
          'CV û nameya motîvasyonê',
          'Belgeya wekheviya dîplomayê',
          'Belgeyên daxwaziya karê',
          'Nameyên referansê'
        ],
        tips: [
          'Dîplomayên xwe nas bikin',
          'CV-yeke bi şêwaza hollandî amade bike',
          'Tora xweya pîşeyî fireh bike',
          'Derfetên staj û karên dilxwazî binirxîne'
        ]
      },
      step6: {
        shortTitle: 'Welatîtî',
        title: 'Welatîtî û Paşê',
        description: 'Daxwaziya welatîtiya hollandî û yekbûna tevahî di civakê de',
        duration: '5+ sal',
        documents: [
          'Belgeya destûra nîştecivaniya 5 salî',
          'Belgeya serketina îmtîhana yekbûnê',
          'Belgeyên dahat û bac',
          'Belgeya tomarê tawanbar'
        ],
        tips: [
          'Hemû pêdiviyên hiqûqî bicîh bîne',
          'Beşdariya çalak di civakê de nîşan bide',
          'Berpirsiyariyên xwe yên darayî bicîh bîne',
          'Nirxên hollandî qebûl bike'
        ]
      }
    }
  }
};

export default ku;